import React from 'react'
import { Container,Row,Col } from 'react-bootstrap'
function Footer() {
  return (
    <footer className="site-footer">
      <span><i className="fa-solid fa-graduation-cap me-2"></i>Series 65 Full Course</span>
      {' '}— Study smart. Pass with confidence. &copy; {new Date().getFullYear()}
    </footer>
  )
}

export default Footer
